const API_KEY = "397350bdf288cf002a86cfe67240e405";
const BASE_PATH = "https://api.themoviedb.org/3";

interface IGenre {
  id: number;
  name: string;
}

interface IProductionCompanies {
  name: string;
  id: number;
  logo_path: string;
  original_country: string;
}

interface IProductionCountries {
  iso_3166_1: string;
  name: string;
}

export interface IMovieDetails {
  backdrop_path: string;
  genres: IGenre[];
  id: number;
  overview: string;
  poster_path: string;
  production_companies: IProductionCompanies[];
  production_countries: IProductionCountries[];
  release_date: string;
  runtime: number;
  status: string;
  tagline: string;
  title: string;
  vote_average: number;
}

export interface IMovie {
  id: number;
  backdrop_path: string;
  poster_path: string;
  title: string;
  overview: string;
  vote_average: number;
  runtime: number;
  tagline: string;
  genres: IGenre[];
}

export interface IGetMoviesResult {
  dates: {
    maximum: string;
    minimum: string;
  };
  page: number;
  results: IMovie[];
  total_pages: number;
  total_results: number;
}

// Movies
export const getMovie = (
  movieId: number | undefined | null
): Promise<IMovieDetails> | undefined => {
  if (!movieId) return;
  return fetch(`${BASE_PATH}/movie/${movieId}?api_key=${API_KEY}`).then(
    (response) => response.json()
  );
};

export const getNowPlayingMovies = () => {
  return fetch(`${BASE_PATH}/movie/now_playing?api_key=${API_KEY}`).then(
    (response) => response.json()
  );
};

export const getTopRatedMovies = () => {
  return fetch(`${BASE_PATH}/movie/top_rated?api_key=${API_KEY}`).then(
    (response) => response.json()
  );
};

export const getUpcomingMovies = () => {
  return fetch(`${BASE_PATH}/movie/upcoming?api_key=${API_KEY}`).then(
    (response) => response.json()
  );
};
